import Swiper from 'swiper'

const advantagesSliderSwiper = new Swiper('#traffic-slider', {
  spaceBetween: 24,
  loop: true,
  slidesPerView: 1,
  speed: 600,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1280: {
      slidesPerView: 3
    },
    1440: {
      slidesPerView: 4
    }
  },
  pagination: {
    el: '.swiper-custom-pagination',
    dynamicBullets: true
  }
})
const delierySliderSwiper = new Swiper('#delivery-services-slider', {
  spaceBetween: 24,
  loop: true,
  slidesPerView: 1,
  speed: 600,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1280: {
      slidesPerView: 3
    },
    1440: {
      slidesPerView: 4
    }
  },
  pagination: {
    el: '.swiper-custom-pagination',
    dynamicBullets: true
  }
})
const messageSliderSwiper = new Swiper('#message-delivery-slider', {
  spaceBetween: 24,
  loop: true,
  slidesPerView: 1,
  speed: 600,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1280: {
      slidesPerView: 3
    },
    1440: {
      slidesPerView: 4
    }
  },
  pagination: {
    el: '.swiper-custom-pagination',
    dynamicBullets: true
  }
})
const paymentsSliderSwiper = new Swiper('#payments-slider', {
  spaceBetween: 24,
  loop: true,
  slidesPerView: 1,
  speed: 600,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1280: {
      slidesPerView: 3
    },
    1440: {
      slidesPerView: 4
    }
  },
  pagination: {
    el: '.swiper-custom-pagination',
    dynamicBullets: true
  }
})
